import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Logo from 'images/logo-new.svg'
import { HOME_ROUTE } from 'routes/constants'

const StickyLogo = ({ isMenuOpen, isSliderOn }) => {
  return (
    <div
      className={cx('sticky-logo-container', {
        'is-menu-open': isMenuOpen,
        'is-digitalSlider--active': isSliderOn,
      })}
    >
      <div className="sticky-logo">
        <Link
          className="sticky-logo-link"
          to={HOME_ROUTE}
          aria-label="Studio logo home link"
        >
          <span className="nav-logo-container">
            <Logo className="nav-logo expanded-logo" />
          </span>
        </Link>
      </div>
    </div>
  )
}

StickyLogo.propTypes = {
  isMenuOpen: PropTypes.bool,
  isSliderOn: PropTypes.bool,
}

export default StickyLogo
